var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.448841,
    y: -0.448841,
    width: 39.1023,
    height: 39.1023,
    rx: 5.63812,
    transform: "matrix(-3.95208e-08 -1 -1 4.83464e-08 39.1023 39.1023)",
    fill: "#EE0B0B",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.448841,
    y: -0.448841,
    width: 39.1023,
    height: 39.1023,
    rx: 5.63812,
    transform: "matrix(-3.95208e-08 -1 -1 4.83464e-08 39.1023 39.1023)",
    stroke: "#EE0B0B",
    strokeWidth: 0.897682
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5368 19.0629L23.8409 14.7588L25.0707 15.9885L20.7666 20.2927L25.0707 24.5968L23.8409 25.8265L19.5368 21.5224L15.2327 25.8265L14.0029 24.5968L18.3071 20.2927L14.0029 15.9885L15.2327 14.7588L19.5368 19.0629Z",
    fill: "#EE0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconRed);
export default __webpack_public_path__ + "static/media/closeIconRed.217cd6b0.svg";
export { ForwardRef as ReactComponent };